export default function getResource(label, vars = []) {
    const resources = {
        addToBasketShort: 'Add',
        remove: 'Remove',
        signInToAccess: 'Sign in to access',
        exclusive: 'Exclusive'
    };
    return resources[label];
}
